import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { createNote } from "../services/create-note";

export function useCreateNote() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      user_id,
      content,
    }: {
      user_id: string;
      content: string;
    }) =>
      createNote({
        user_id,
        content,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["users"], exact: false });
      toast({
        title: "Success",
        description: "Note saved successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to save note",
        variant: "destructive",
      });
    },
  });
}

